package com.fireavert.reboot.presentation

data class RebootViewState(
    val deviceId: String? = null,
    val deviceError: Boolean = false,
    val success: Boolean? = null,
    val deviceNotActive: Boolean = false,
    val isOffline: Boolean = false
)
